/** Device list columns (Devices page). */
export const DEVICE_COLUMNS = [
  { id: 'hostname', label: 'Hostname', defaultVisible: true },
  { id: 'display_name', label: 'Display name', defaultVisible: true },
  { id: 'customer', label: 'Customer', defaultVisible: true, hideForCustomer: true },
  { id: 'os_name', label: 'OS', defaultVisible: true },
  { id: 'os_build', label: 'Build', defaultVisible: false },
  { id: 'machine_type', label: 'Type', defaultVisible: true },
  { id: 'cpu_name', label: 'Processor', defaultVisible: true },
  { id: 'cpu_cores', label: 'Cores', defaultVisible: true },
  { id: 'ram_mb', label: 'RAM', defaultVisible: true },
  { id: 'domain', label: 'Domain', defaultVisible: false },
  { id: 'last_logged_user', label: 'Last user', defaultVisible: false },
  { id: 'agent_version', label: 'Agent ver.', defaultVisible: false },
  { id: 'online_status', label: 'Online', defaultVisible: true },
  { id: 'security_status', label: 'Security', defaultVisible: true },
  { id: 'hardware_status', label: 'Hardware', defaultVisible: true },
  { id: 'toolkit_status', label: 'Toolkit', defaultVisible: true },
  { id: 'last_seen', label: 'Last seen', defaultVisible: true },
  { id: 'last_reboot_time', label: 'Last reboot', defaultVisible: true },
  { id: 'windows_serial_number', label: 'Windows serial', defaultVisible: true },
  { id: 'folder_name', label: 'Folder', defaultVisible: true },
  { id: 'app_view_url', label: 'Atera link', defaultVisible: true },
  { id: 'computer_description', label: 'Description', defaultVisible: true },
  { id: 'reported_from_ip', label: 'Reported IP', defaultVisible: true },
  { id: 'system_drive', label: 'System drive', defaultVisible: true },
  { id: 'created_at_atera', label: 'Created (Atera)', defaultVisible: true },
  { id: 'modified_at_atera', label: 'Modified (Atera)', defaultVisible: true },
  { id: 'av_product', label: 'AV product', defaultVisible: true },
  { id: 'av_status', label: 'AV status', defaultVisible: true },
]

const HW_COLS = [
  { id: 'atera_id', label: 'Device ID', defaultVisible: false },
  { id: 'hostname', label: 'Hostname', defaultVisible: true },
  { id: 'display_name', label: 'Display name', defaultVisible: true },
  { id: 'customer_name', label: 'Customer', defaultVisible: true },
  { id: 'os_name', label: 'OS', defaultVisible: true },
  { id: 'os_version', label: 'OS version', defaultVisible: false },
  { id: 'os_build', label: 'Build', defaultVisible: false },
  { id: 'machine_type', label: 'Type', defaultVisible: true },
  { id: 'cpu_name', label: 'Processor', defaultVisible: true },
  { id: 'cpu_cores', label: 'Cores', defaultVisible: true },
  { id: 'cpu_speed_mhz', label: 'CPU speed (MHz)', defaultVisible: false },
  { id: 'ram_mb', label: 'RAM', defaultVisible: true },
  { id: 'domain', label: 'Domain', defaultVisible: false },
  { id: 'last_logged_user', label: 'Last user', defaultVisible: false },
  { id: 'agent_version', label: 'Agent ver.', defaultVisible: false },
  { id: 'online_status', label: 'Online', defaultVisible: true },
  { id: 'last_seen', label: 'Last seen', defaultVisible: false },
  { id: 'last_reboot_time', label: 'Last reboot', defaultVisible: false },
  { id: 'windows_serial_number', label: 'Windows serial', defaultVisible: false },
  { id: 'folder_name', label: 'Folder', defaultVisible: false },
  { id: 'app_view_url', label: 'Atera link', defaultVisible: false },
  { id: 'computer_description', label: 'Description', defaultVisible: false },
  { id: 'reported_from_ip', label: 'Reported IP', defaultVisible: false },
  { id: 'system_drive', label: 'System drive', defaultVisible: false },
  { id: 'created_at_atera', label: 'Created (Atera)', defaultVisible: false },
  { id: 'modified_at_atera', label: 'Modified (Atera)', defaultVisible: false },
]

/** Per-report column metadata (Reports preview). */
export const REPORT_COLUMNS = {
  'hardware-summary': HW_COLS,
  'asset-list': [
    { id: 'atera_id', label: 'Device ID', defaultVisible: false },
    { id: 'customer_id', label: 'Customer ID', defaultVisible: false },
    { id: 'customer_name', label: 'Customer', defaultVisible: true },
    { id: 'hostname', label: 'Hostname', defaultVisible: true },
    { id: 'display_name', label: 'Display name', defaultVisible: true },
    { id: 'os_name', label: 'OS', defaultVisible: true },
    { id: 'os_version', label: 'OS version', defaultVisible: true },
    { id: 'os_build', label: 'Build', defaultVisible: false },
    { id: 'machine_type', label: 'Type', defaultVisible: true },
    { id: 'cpu_name', label: 'Processor', defaultVisible: false },
    { id: 'cpu_cores', label: 'Cores', defaultVisible: false },
    { id: 'ram_mb', label: 'RAM', defaultVisible: true },
    { id: 'domain', label: 'Domain', defaultVisible: false },
    { id: 'online_status', label: 'Online', defaultVisible: true },
    { id: 'last_seen', label: 'Last seen', defaultVisible: true },
  ],
  'os-breakdown': [
    { id: 'os_name', label: 'Operating system', defaultVisible: true },
    { id: 'count', label: 'Device count', defaultVisible: true },
  ],
  'alerts-summary': [
    { id: 'atera_id', label: 'Alert ID', defaultVisible: false },
    { id: 'title', label: 'Title', defaultVisible: true },
    { id: 'message', label: 'Detail', defaultVisible: true },
    { id: 'severity', label: 'Severity', defaultVisible: true },
    { id: 'source', label: 'Source', defaultVisible: false },
    { id: 'code', label: 'Code', defaultVisible: false },
    { id: 'category', label: 'Category', defaultVisible: false },
    { id: 'is_active', label: 'Alert status', defaultVisible: true },
    { id: 'created', label: 'Created', defaultVisible: true },
    { id: 'cleared', label: 'Cleared', defaultVisible: false },
    { id: 'archived_at', label: 'Archived', defaultVisible: false },
    { id: 'device_name', label: 'Device (alert)', defaultVisible: true },
    { id: 'hostname', label: 'Hostname', defaultVisible: false },
    { id: 'device_type', label: 'Device type', defaultVisible: false },
    { id: 'customer_name', label: 'Customer', defaultVisible: true },
    { id: 'portal_customer_name', label: 'Customer (portal)', defaultVisible: false },
  ],
  'patch-details': [
    { id: 'status', label: 'Status', defaultVisible: true },
    { id: 'title', label: 'Update', defaultVisible: true },
    { id: 'kb_number', label: 'KB', defaultVisible: true },
    { id: 'severity', label: 'Class', defaultVisible: false },
    { id: 'hostname', label: 'Device', defaultVisible: true },
    { id: 'display_name', label: 'Display name', defaultVisible: false },
    { id: 'customer_name', label: 'Customer', defaultVisible: true },
    { id: 'agent_id', label: 'Device ID', defaultVisible: false },
    { id: 'install_date', label: 'Installed', defaultVisible: true },
    { id: 'synced_at', label: 'Synced', defaultVisible: false },
  ],
  'software-audit': [
    { id: 'software', label: 'Software', defaultVisible: true },
    { id: 'hostname', label: 'Device', defaultVisible: true },
    { id: 'display_name', label: 'Display name', defaultVisible: false },
    { id: 'customer_name', label: 'Customer', defaultVisible: true },
    { id: 'agent_id', label: 'Device ID', defaultVisible: false },
    { id: 'install_date', label: 'Installed', defaultVisible: true },
  ],
  'patch-status': [
    { id: 'status', label: 'Status', defaultVisible: true },
    { id: 'count', label: 'Count', defaultVisible: true },
  ],
  'security-summary': [
    { id: 'customer_name', label: 'Customer', defaultVisible: true, hideForCustomer: true },
    { id: 'hostname', label: 'Hostname', defaultVisible: true },
    { id: 'display_name', label: 'Display name', defaultVisible: false },
    { id: 'defender_status', label: 'Defender', defaultVisible: true },
    { id: 'defender_threats', label: 'Defender threats', defaultVisible: true },
    { id: 'threatdown_status', label: 'ThreatDown', defaultVisible: true },
    { id: 'threatdown_online', label: 'ThreatDown online', defaultVisible: false },
    { id: 'bitlocker_encrypted', label: 'BitLocker', defaultVisible: true },
    { id: 'lowest_disk_free_pct', label: 'Lowest disk %', defaultVisible: true },
    { id: 'firewall', label: 'Firewall', defaultVisible: true },
    { id: 'reboot_required', label: 'Reboot required', defaultVisible: true },
    { id: 'macros_allowed', label: 'Macros allowed', defaultVisible: true },
    { id: 'dotnet6_installed', label: '.NET 6 installed', defaultVisible: true },
    { id: 'dotnet6_products', label: '.NET 6 products', defaultVisible: false },
    { id: 'winget_installed', label: 'Winget installed', defaultVisible: true },
    { id: 'winget_products', label: 'Winget products', defaultVisible: false },
    { id: 'secure_boot', label: 'Secure Boot', defaultVisible: false },
    { id: 'tpm_enabled', label: 'TPM enabled', defaultVisible: false },
    { id: 'local_admin_count', label: 'Local admins', defaultVisible: true },
    { id: 'failed_logins_today', label: 'Failed logins (today)', defaultVisible: true },
    { id: 'admin_changes_today', label: 'Admin changes (today)', defaultVisible: true },
    { id: 'toolkit_health', label: 'Toolkit health', defaultVisible: true },
    { id: 'toolkit_score', label: 'Toolkit score', defaultVisible: true },
    { id: 'toolkit_failures', label: 'Toolkit failures', defaultVisible: false },
    { id: 'toolkit_warnings', label: 'Toolkit warnings', defaultVisible: false },
    { id: 'toolkit_script_name', label: 'Toolkit check', defaultVisible: false },
    { id: 'agent_id', label: 'Device ID', defaultVisible: false },
  ],
}

export function defaultVisibleColumnIds(columns) {
  return columns.filter((c) => c.defaultVisible !== false).map((c) => c.id)
}

export function getReportColumns(slug) {
  return REPORT_COLUMNS[slug] || []
}
